<template>
  <div :id="parentContainerId+'-'+stringToClass(tagName)"
       :class="{
          tag: display === 'tag',
          category: isCategory,
          'tag-text': display === 'text',
          'tag-with-delete': display === 'tag',
          'tag-negative': tag.negative
         }"
       :tag-data="stringToClass(tagName)"
       :tag-grouping="tagParentId"
        @dblclick="(e) => negateMentionTag(e, tag)"
       >

      <span v-if="display === 'tag'">
        {{ displayName }}

        <div v-if="settingsEnabled" :class="['fas fa-cog', { active: hasSettingsValues }]" v-on:click="(e) => toggleSettings(e, tag)" />
        <div class="delete-tag fas fa-times"
           v-on:click="(e) => deleteMentionTag(e, tag)" />
      </span>
      <span v-else-if="display === 'text'">
        <span v-if="tag.negative === true" class="joiner not">{{$t('advanced.not')}}</span>
        <span class="category-name">{{ tagParentName }}</span>
        <span class="tag-name">{{ ': ' + tagName }}</span>
      </span>

      
  </div>
</template>

<script>
  import editor from '../../helpers/editor';

  export default {
    props: {
      parentContainerId: String,
      tag: Object,
      display: {
        type: String,
        default: () => 'tag'
      },
    },
    computed: {
      tagName () {
        return this.tag.tag_name || this.tag.name;
      },
      tagParentId () {
        return this.tag.category_id || this.tag.breakdown_id;
      },
      tagParentName () {
        return this.tag.category_name || this.tag.breakdown_name;
      },
      displayName () {
        return this.isCategory ? this.tagName : this.tagParentName + ': ' + this.tagName;
      },
      isCategory () {
        return this.tag.type === 'category';
      },
      settingsEnabled () {
        return this.$listeners && this.$listeners.toggleSettings && ['category','tag', 'breakdown'].includes(this.tag.type);
      },
      hasSettingsValues () {
        if (!this.settingsEnabled) return;

        let settingsAreSet = false;
        const settings = this.tag.settings;
        if (settings) {
          const keys = Object.keys(settings);
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (Array.isArray(settings[key]) && settings[key].length > 0) {
              settingsAreSet = true;
            }
          }
        }
        
        return settingsAreSet;
      }
    },
    methods: {
      stringToClass(string) {
        return editor.stringToClass(string);
      },
      deleteMentionTag(e, tag) {
        e.preventDefault();
        e.stopPropagation();

        this.$emit('deleteMentionTag', tag);
      },
      negateMentionTag(e, tag) {
        this.$emit('negateMentionTag', tag)
      },
      toggleSettings(e, tag) {
        this.$emit('toggleSettings', tag);
      }
    }
  }
</script>